<template>
  <DeleteConfirm
      itemKey="Expense"
      :fetchData="fetchData"
      :setTitle="setTitle"
      :setQuestion="setQuestion"
      :deleteData="deleteData"
      @onDelete="(response) => $emit('onDelete', response)"
      v-bind="$attrs"
  />
</template>

<script>
  import Expenses from '@/services/expenses'

  import DeleteConfirm from '@/components/_Part/_Modal/_Confirm/Delete'

  export default {
    name: 'Delete',
    props: [
      'id'
    ],
    emits: [
      'onDelete'
    ],
    components: {
      DeleteConfirm
    },
    methods: {
      fetchData() {
        return Expenses
          .read({
            id: this.id
          })
      },
      setTitle(Item) {
        return 'Odstrániť výdaj "' + Item.title + '"  z ' + this.$moment(Item.paidAt).format('DD.MM.YYYY')
      },
      setQuestion(Item) {
        return 'Naozaj chcete odstrániť výdaj "' + Item.title + '"  z ' + this.$moment(Item.paidAt).format('DD.MM.YYYY') + '?'
      },
      deleteData() {
        return Expenses
          .delete({
            id: this.id
          })
      }
    }
  }
</script>
